const $ = window.jQuery;

$(document).ready(() => {
    const $parent = $('.js-select-container');
    let $href;

    if ($parent.length === 0) {
        return;
    }

    // const $phone = {
    //     group: $('.js-phone-group'),
    //     private: $('.js-phone-private'),
    //     cater: $('.js-phone-cater'),
    // };

    $parent
        .find('.js-select')
        .on('change', evt => {
            const $field = $(evt.target);
            const $fieldParent = $field.closest('.js-select-container');
            // const type = $field.attr('name');
            const groupNumber = $field.find('option:selected').data('group');
            const phoneNumber = $field.find('option:selected').data('phone');

            if(groupNumber) {
                $href = "/group-dining-request/?location_id=";
                $href += groupNumber;
            }

            console.log($href);

            $fieldParent.find('.js-group-id').attr('href', $href);
            $fieldParent.find('.js-phone').text(phoneNumber);  
            $fieldParent.find('.js-phone').attr('href', 'tel:'+phoneNumber);            
        })
        .trigger('change');
});
